import { defineModule } from 'direct-vuex'
import { moduleActionContext } from '..'
import api from '@/api'
import { FeatureFlagsQuery, FeatureFlagsQueryVariables } from '@/api/graphql-sdk.generated'

export interface FeatureState {
  config: FeatureFlagsQuery['featureFlags']
}

const createInitialState = (): FeatureState => ({
  config: []
})

const feature = defineModule({
  namespaced: true,
  state: createInitialState,
  getters: {
    hasFeature: (state: FeatureState) => (featureKey: string, customConfig?: FeatureFlagsQuery['featureFlags']) => {
      let { config } = state
      if (customConfig) config = customConfig
      const feature = config.find((feature) => feature.key === featureKey)
      return feature && feature.enabled
    },
    featureConfig: (state: FeatureState) => (featureKey: string) => {
      const { config } = state
      const feature = config.find((feature) => feature.key === featureKey)
      return feature?.config
    }
  },
  mutations: {
    setConfig (state: FeatureState, config: FeatureFlagsQuery['featureFlags']) {
      state.config = config
    }
  },
  actions: {
    async getFeatureConfig (context, payload: FeatureFlagsQueryVariables) {
      const res = await api.getFeatureConfig(payload)
      const { commit } = featureActionContext(context)
      commit.setConfig(res)
    }
  }
})

export default feature
export const featureActionContext = (context: any) => moduleActionContext(context, feature)
